/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { SearchSuggestionItem } from '../../api/search.types';

/**
 * Curated list of city and national park locations for empty-state suggestions.
 * Used to pick 3 random suggestions when the locations combobox is open with no query.
 */
export const SUGGESTION_LOCATIONS: SearchSuggestionItem[] = [
    {
        text: 'Washington, DC',
        lat: '38.90253000000000',
        lng: '-77.03938599999999',
        location: 'Washington, District of Columbia',
        type: 'location',
        icon: 'pin',
        id: '38.90253000000000--77.03938599999999',
    },
    {
        text: 'Wrangell-St. Elias National Park, AK',
        icon: 'tree',
        lat: '61.51074000000000',
        lng: '-144.06998999999999',
        location: 'Wrangell-St. Elias National Park, Alaska',
        id: '2986',
        type: 'location',
    },
    {
        text: 'Great Basin National Park, NV',
        icon: 'tree',
        lat: '39.00339500000000',
        lng: '-114.21753000000000',
        location: 'Great Basin National Park, Nevada',
        id: '2732',
        type: 'location',
    },
    {
        text: 'Crater Lake National Park, OR',
        icon: 'tree',
        lat: '42.89536700000000',
        lng: '-122.13453000000000',
        location: 'Crater Lake National Park, Oregon',
        id: '2647',
        type: 'location',
    },
    {
        text: 'Capitol Reef National Park, UT',
        icon: 'tree',
        lat: '38.29158800000000',
        lng: '-111.26121500000001',
        location: 'Capitol Reef National Park, Utah',
        id: '2617',
        type: 'location',
    },
    {
        text: 'Canyonlands National Park, UT',
        icon: 'tree',
        lat: '38.15499500000000',
        lng: '-109.75413000000000',
        location: 'Canyonlands National Park, Utah',
        id: '2616',
        type: 'location',
    },
    {
        text: 'Acadia National Park, ME',
        icon: 'tree',
        lat: '44.39134600000000',
        lng: '-68.23549000000000',
        location: 'Acadia National Park, Maine',
        id: '2554',
        type: 'location',
    },
    {
        text: 'Badlands National Park, SD',
        icon: 'tree',
        lat: '43.74743000000000',
        lng: '-101.94771000000000',
        location: 'Badlands National Park, South Dakota',
        id: '2578',
        type: 'location',
    },
    {
        text: 'Olympic National Park, WA',
        icon: 'tree',
        lat: '48.09818000000000',
        lng: '-123.42521000000001',
        location: 'Olympic National Park, Washington',
        id: '2881',
        type: 'location',
    },
    {
        text: 'Rocky Mountain National Park, CO',
        icon: 'tree',
        lat: '40.36249000000000',
        lng: '-105.56328600000001',
        location: 'Rocky Mountain National Park, Colorado',
        id: '2907',
        type: 'location',
    },
    {
        text: 'Glacier National Park, MT',
        icon: 'tree',
        lat: '48.49950800000000',
        lng: '-113.98294000000000',
        location: 'Glacier National Park, Montana',
        id: '2725',
        type: 'location',
    },
    {
        text: 'Haleakala National Park, HI',
        icon: 'tree',
        lat: '20.71468200000000',
        lng: '-156.25116000000000',
        location: 'Haleakala National Park, Hawaii',
        id: '2751',
        type: 'location',
    },
    {
        text: 'Great Sand Dunes National Park, CO',
        icon: 'tree',
        lat: '37.85323300000000',
        lng: '-105.64678000000001',
        location: 'Great Sand Dunes National Park, Colorado',
        id: '2738',
        type: 'location',
    },
    {
        text: 'Hot Springs National Park, AR',
        icon: 'tree',
        lat: '34.51590700000000',
        lng: '-93.06560000000000',
        location: 'Hot Springs National Park, Arkansas',
        id: '2760',
        type: 'location',
    },
    {
        text: 'Everglades National Park, FL',
        icon: 'tree',
        lat: '25.76072300000000',
        lng: '-80.82844000000000',
        location: 'Everglades National Park, Florida',
        id: '2677',
        type: 'location',
    },
    {
        text: 'Great Smoky Mountains National Park, TN',
        icon: 'tree',
        lat: '35.72046000000000',
        lng: '-83.64568000000000',
        location: 'Great Smoky Mountains National Park, Tennessee',
        id: '2739',
        type: 'location',
    },
    {
        text: 'Shenandoah National Park, VA',
        icon: 'tree',
        lat: '38.90782500000000',
        lng: '-78.19430000000000',
        location: 'Shenandoah National Park, Virginia',
        id: '2933',
        type: 'location',
    },
    {
        text: 'Grand Canyon National Park, AZ',
        icon: 'tree',
        lat: '36.05391700000000',
        lng: '-112.14471000000000',
        location: 'Grand Canyon National Park, Arizona',
        id: '2733',
        type: 'location',
    },
    {
        text: 'Isle Royale National Park, MI',
        icon: 'tree',
        lat: '47.91240000000000',
        lng: '-89.15595000000000',
        location: 'Isle Royale National Park, Michigan',
        id: '2769',
        type: 'location',
    },
    {
        text: 'Monongahela National Forest, WV',
        id: '1090',
        icon: 'tree',
        lat: '38.55399900000000',
        lng: '-79.89634700000001',
        location: 'Monongahela National Forest, WV',
        type: 'inventory',
    },
    {
        text: 'Green Mountain & Finger Lakes National Forests, VT',
        id: '1089',
        icon: 'tree',
        lat: '43.62566200000000',
        lng: '-72.97575500000001',
        location: 'Green Mountain & Finger Lakes National Forests',
        type: 'inventory',
    },
    {
        text: 'Coconino National Forest, AZ',
        id: '1092',
        icon: 'tree',
        lat: '35.20000000000000',
        lng: '-111.45000000000000',
        location: 'Coconino National Forest Recreation',
        type: 'inventory',
    },
    {
        text: 'Grand Mesa, Uncompahgre and Gunnison National Forest',
        id: '1052',
        icon: 'tree',
        lat: '38.51815700000000',
        lng: '-107.46104200000001',
        location: 'Grand Mesa, Uncompahgre and Gunnison National Forest',
        type: 'inventory',
    },
    {
        text: 'Fremont-Winema National Forest, OR',
        id: '1104',
        icon: 'tree',
        lat: '42.59400000000000',
        lng: '-121.55700000000000',
        location: 'Fremont-Winema National Forest, OR',
        type: 'inventory',
    },
];

// cSpell:ignore canyonlands, royale with cheese, winema
